import { initSubRoutes } from '../../../../../../../utils/router';

const RoutesRepriseDonnees = initSubRoutes({
    route: '/reprise-de-donnees/:uuidArmeSelec',
    subroutes: {},
    nom: 'Corriger arme',
});

export default RoutesRepriseDonnees;
